import type { i18n } from 'i18next'

export const tlIfExists = (i18n: i18n, key: string, fallback?: string) => {
  if (i18n.exists(key)) {
    return i18n.t(key)
  }
  return fallback ?? key
}
